import { ContentTag } from "scrivito"
import { PortfolioPageObj } from "scrivito/Objs/PortfolioPage/PortfolioPageObjClass"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"
import { ProductCategoryOverview } from "widgets/product-category-overview/ProductCategoryOverview"

import { usePortfolioPageModel } from "./model/usePortfolioPageModel"
import "./styles/_portfolio-page.scss"

interface PortfolioPageProps {
  page: PortfolioPageObj
}

export function PortfolioPage({ page }: PortfolioPageProps) {
  useScrollController()
  useScrivitoPage()

  const { defaultValues, categories, products, filterState, onChange } =
    usePortfolioPageModel({ page })

  return (
    <div id="portfolio-page" className="portfolio-page">
      <ContentTag content={page} attribute="breadcrumbWidget" />
      <ProductCategoryOverview
        page={page}
        productCategories={categories}
        products={products}
        filter={filterState}
        onFilterChange={onChange}
        defaultFilter={defaultValues}
      />
    </div>
  )
}
